import PropTypes from 'prop-types';
import React from 'react';
import './switch.styles.css';

function CustomSwitch({ name, data, setData }) {
	const handleChange = (e) => {
		setData((preValue) => ({ ...preValue, [e.target.name]: e.target.checked }));
	};

	return (
		<div className='pointer-css'>
			<input
				type='checkbox'
				onChange={handleChange}
				name={name}
				id={name}
				checked={data[name]}
				className='checkbox pointer-css'
			/>
			<button
				type='button'
				className='toggle pointer-css'
				onClick={() => document.querySelector(`#${name}`).click()}
				aria-pressed={data[name]}
				aria-labelledby={name}
			></button>
		</div>
	);
}

export default CustomSwitch;

CustomSwitch.propTypes = {
	name: PropTypes.any,
	data: PropTypes.any,
	setData: PropTypes.any
};
